import util from '@utils/util';
import socialContact from './social-contact';
// import feedback from '../../feedback-alive';

export default {
  name: 'alive-footer',
  components: {
    socialContact: socialContact
    // feedback
  },
  computed: {
    crtime: function crtime() {
      return new Date().getFullYear();
    },
    companyName: function companyName() {
      return window.location.hostname === 'www.shanghaileyu.com' ? '上海勒域科技有限公司(Shanghai Leyu Science and Technology Center)' : '';
    }
  },
  methods: {
    // 显示反馈
    clickShowFeedBack: function clickShowFeedBack() {
      this.$lmBus.$emit('clickShowFeedBack', 'convertView');
    },
    getLink: function getLink(pathname) {
      // 带参传递
      var json = {
        pathname: pathname,
        search: {}
      };
      return util.directToPath(json);
    }
  }
};